import { render, staticRenderFns } from "./googleAvisModule.vue?vue&type=template&id=6de84745"
import script from "./googleAvisModule.vue?vue&type=script&lang=js"
export * from "./googleAvisModule.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./googleAvisModule.vue?vue&type=style&index=0&id=6de84745&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports